export const chase = false;
export const clouds = false;
export const hint = 'Drive carefully at night.';
export const zoomed = false;
export const cars = true;
export const night = true;
export const map = `
xutxx
xxfxx
xtxxt
rrrrr
yxxtx
yuhxx
yxxxy
`